<template>
  <v-badge
    :color="badgeColor"
    :model-value="
      !!opinion.nonSegmentedProfileCategoryRank &&
      !!opinion.profileCategoryRank.rank
    "
    floating
  >
    <template #badge>
      <template v-if="change === 0">-</template>
      <template v-else>
        <v-icon v-if="change > 0">mdi-arrow-up</v-icon>
        <v-icon v-else>mdi-arrow-down</v-icon>
        {{ Math.abs(change) }}
      </template>
    </template>
    <span class="text-no-wrap">
      {{ numberToOrdinal(opinion.profileCategoryRank.rank) }}
    </span>
  </v-badge>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { numberToOrdinal } from '@/composables/utilities';

const props = defineProps<{
  opinion: Record<string, any>;
}>();

const change = computed(
  () =>
    props.opinion.nonSegmentedProfileCategoryRank -
    props.opinion.profileCategoryRank.rank,
);
const badgeColor = computed(() => {
  if (change.value === 0) {
    return 'blue-grey lighten-2';
  } else if (change.value > 0) {
    return 'success';
  } else {
    return 'error';
  }
});
</script>
